import { createAction, props } from '@ngrx/store';

export const openProprietaryFertilizersOverview = createAction(
  '[Proprietary fertilizers overview] Open proprietary fertilizers overview',
);

export const createProprietaryFertilizer = createAction(
  '[Proprietary fertilizers overview] Create proprietary fertilizer',
);

export const editProprietaryFertilizer = createAction(
  '[proprietary fertilizers overview] Edit proprietary fertilizer',
  props<{ proprietaryFertilizerId: number }>(),
);
